<template>
	<Card>
		<template #content>
			<div class="flex flex-col gap-8">
				<FormGroup :label="$t('forms.user.user_properties_form.name')" :error-text="form.errors?.name">
					<InputText ref="name" v-model="form.name" placeholder="e.g. Joe Bloggs" @change="form.validate('name')"/>
				</FormGroup>

				<FormGroup :label="$t('forms.user.user_properties_form.email')" :error-text="form.errors?.email">
					<InputText ref="email" v-model="form.email" placeholder="e.g. joe.bloggs@example.com"
					           @change="form.validate('email')"/>
				</FormGroup>

				<FormGroup :label="$t('forms.user.user_properties_form.primary_company')" :error-text="form.errors?.primary_company_id" >
				<Dropdown
					v-model="form.primary_company_id"
					:options="availableCompanies"
					option-label="name"
					option-value="id"
					@change="form.validate('primary_company_id')"
					:placeholder="$t('common.na')"
					show-clear
				/>
				</FormGroup>

				<FormGroup :label="$t('forms.user.user_properties_form.two_factor_auth')">
					<!-- form.two_factor_enabled: {{ form.two_factor_enabled }} -->
					 <!-- {{ form }} -->
					<ToggleButton
						v-model="form.two_factor_enabled"
						:disabled="!initialTwoFactorState"
						:on-label="$t('forms.user.user_properties_form.enabled')"
						:off-label="$t('forms.user.user_properties_form.disabled')"
						@change="form.validate('two_factor_enabled')"
					/>
				</FormGroup>
			</div>
		</template>

		<template v-if="hasOnSaveListener || hasOnDeleteListener" #footer>
			<div class="flex justify-end space-x-3">
				<Button class="px-8" severity="danger" text v-if="hasOnDeleteListener" @click="$emit('on-delete', form)"
				        :label="$t('forms.common.delete')"
				        :disabled="form.processing"/>
				<Button class="px-8" v-if="hasOnSaveListener" @click="$emit('on-save', form)" :label="$t('forms.common.save')"
				        :disabled="form.processing"/>
			</div>
		</template>
	</Card>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";

export default {
	name: "UserPropertiesForm",
	components: {FormGroup},
	props: {
		form: {
			type: Object,
			required: true,
		},
    availableCompanies: {
      type: Array,
      required: true,
    }
	},
	computed: {
		hasOnSaveListener() {
			return !!(this.$attrs?.onOnSave);
		},
		hasOnDeleteListener() {
			return !!(this.$attrs?.onOnDelete);
		},
	},
	data(){
		return {
			initialTwoFactorState: false,
		}
	},
	mounted() {
		this.$refs.name.$el.focus();
		this.initialTwoFactorState = this.form.two_factor_enabled;
	}
}
</script>

<style scoped>

</style>
